var React = require('react');

function UserIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"user","d":"M15.7 14.9c-2.6-1-3.5-1.8-3.5-3.6 0-1.1.8-.7 1.2-2.7.1-.8.9 0 1-1.9 0-.7-.4-.9-.4-.9s.2-1.1.3-2c0-1.1-.7-3.8-4.3-3.8S5.7 2.7 5.8 3.8c.1.9.3 2 .3 2s-.4.1-.4.9c.1 1.9.8 1.1 1 1.9.4 2 1.2 1.6 1.2 2.7 0 1.8-.8 2.6-3.5 3.6-2.6 1-4.3 2-4.3 2.7C0 18.4 0 20 0 20h20v-2.3c0-.7-1.7-1.8-4.3-2.8z"}));
}

UserIcon.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = UserIcon;

UserIcon.default = UserIcon;
